import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orderDetails: [],
};

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
    },
    resetOrderDetails: (state) => {
      state.orderDetails = [];
    },
  },
});

export const { setOrderDetails, resetOrderDetails } = checkoutSlice.actions;
export default checkoutSlice.reducer;
export { initialState as checkoutInitialState };